import { ENTITY_TYPES } from "utility/constants/constants";
import { createProjectShare as createProjectV2Share } from "redux/actions/ProjectsActions";
import { createProjectShare as createProjectV1Share } from "redux/actions/ProjectActions";
import { updateDatasetShare } from "redux/actions/DataSetActions";
import { createWorkflowShare } from "redux/actions/WorkflowActions";
import { createAppShare } from "redux/actions/AppActions";

/**
 * Configuration map for the ShareEntityModal.
 * Maps each entity type to:
 *   - createShare: Redux action creator for creating/updating shares
 *   - label: Human-readable entity name for toast messages
 *   - hasExecute: Whether the "execute" access level is available
 */
export const SHARE_CONFIG = {
  [ENTITY_TYPES.PROJECT_V2]: {
    createShare: createProjectV2Share,
    label: "Project",
    hasExecute: true,
  },
  [ENTITY_TYPES.PROJECT]: {
    createShare: createProjectV1Share,
    label: "Notebook",
    hasExecute: true,
  },
  [ENTITY_TYPES.DATASET]: {
    createShare: updateDatasetShare,
    label: "Dataset",
    hasExecute: false,
  },
  [ENTITY_TYPES.WORKFLOW]: {
    createShare: createWorkflowShare,
    label: "Workflow",
    hasExecute: true,
  },
  [ENTITY_TYPES.APPLICATION]: {
    createShare: createAppShare,
    label: "Application",
    hasExecute: true,
  },
};
